import { action, observable } from 'mobx'
import { validationContext } from 'validx'
import { ConfigEditorViewModelBase } from './ConfigEditorViewModelBase'
import type { TimeConfig } from './legend-options'
import { TIME_ZONE_CHOICES } from './time-zones'

/**
 * The legend's time zone, used when formatting dates with Ryno's `Text`.
 */
export class TimeConfigEditorViewModel extends ConfigEditorViewModelBase<TimeConfig> {
  /**
   * The time zones to pick from, with their labels.
   */
  readonly availableTimeZones = TIME_ZONE_CHOICES

  @observable accessor timeZone = getSystemTimeZone()

  readonly validation = validationContext(this, {})

  /**
   * A legend without a time config uses the browser's time zone.
   */
  @action
  hydrate(config: TimeConfig | undefined) {
    this.timeZone = config ? config.timeZone || 'UTC' : getSystemTimeZone()
  }

  /** @inheritDoc */
  toJSON(): TimeConfig {
    return { timeZone: this.timeZone }
  }
}

function getSystemTimeZone() {
  try {
    return new Intl.DateTimeFormat('en-US').resolvedOptions().timeZone
  } catch {
    return 'UTC'
  }
}
